import { useAppState } from '../context/OmniboxCsvConverterContext';
import { useState } from 'react';
import {
  Box,
  Paper,
  Stack,
} from '@mui/material';

function RenderOutputTable() {
  const { prodLines, delimString } = useAppState();

  const outputLines = delimString.split('\r\n').slice(1);
  const propNames = delimString.split('\r\n')[0].split('\t').slice(0, -2);

  const firstLineValues = outputLines[0].split('\t').slice(0, -2);
  const headerWidths = firstLineValues.map((val, i) => {
    return Math.max(val.length * 10, propNames[i].length * 10, 100).toString() + 'px';
  });
  const gridTemplateColumns = headerWidths.join(' ');
  const totalMinWidth = firstLineValues.reduce((sum, val) => sum + (val.length * 10), 0) + 'px';

  return (
    <Stack direction='column' sx={{ width: '100%' }}>
      <Box
        sx={{
          width: '100%',
          overflowX: 'auto',
          '&::-webkit-scrollbar': { backgroundColor: 'transparent', height: '8px' },
          '&::-webkit-scrollbar-thumb': { backgroundColor: 'text.secondary', borderRadius: 8 },
          '&::-webkit-scrollbar-corner': {backgroundColor: 'transparent' }
        }}
      >
        <Box
          sx={{
            display: 'inline-block',
            minWidth: 'max-content',
          }}
        >
          <Box
            sx={{
              my: 1,
              p: 2,
              backgroundColor: 'secondary.main',
              color: 'white',
              borderRadius: 1,
              border: '1px solid #30363D',
              display: 'grid',
              gridTemplateColumns,
              columnGap: 3,
              minWidth: totalMinWidth,
              whiteSpace: 'nowrap',
            }}
          >
            {propNames.map((propName, i) =>  (
              <Box sx={{ width: headerWidths[i], }}>
                {propName}
              </Box>
            ))}
          </Box>

          <Stack spacing={1}>
            {outputLines.map((line, rowIdx) => (
              <Paper
                key={`row-${rowIdx}`}
                sx={{
                  p: 2,
                  backgroundColor: 'background.paper',
                  border: 1,
                  borderColor: 'divider',
                  borderRadius: 1,
                  display: 'grid',
                  gridTemplateColumns,
                  columnGap: 3,
                  minWidth: totalMinWidth,
                  whiteSpace: 'nowrap',
                  transition: 'all 0.2s',
                  '&:hover': {
                    transform: 'translateY(-2px)',
                    boxShadow: 4,
                  }
                }}
              >
                {line.split('\t').slice(0, -2).map((val, i) => (
                  <Box
                    key={`cell-${rowIdx}-${i}`}
                    title={val}
                    sx={{
                      width: headerWidths[i],
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                    }}
                  >
                    {val}
                  </Box>
                ))}
              </Paper>
            ))}
          </Stack>
        </Box>
      </Box>
    </Stack>
  )
}

export default RenderOutputTable;